export class ApiError extends Error {

    code;

    data;

    constructor(code, message = null, data = null) {
        super(message);
        this.data = data;
        this.code = code;
    }
}
